import { Row, Col } from '../../components/custom';

import firstImage from '../../images/solutions/employeeExp/one.webp';
import secondImage from '../../images/solutions/employeeExp/two.webp';
import thirdImage from '../../images/solutions/employeeExp/three.webp';

export default function EmployeeExp()
{
    return (
        <Col id='employee-experience'>
            <span className='mainTitle title'>Employee Experience Intelligence</span>
            <Row className='big'>
                <img src={firstImage} alt='firstImage'/>
                <Col className='content'>
                    <span className='title'>Understand what your employees are saying — and what they're not.</span>
                    <Col className='descsmall'>
                        <span>Your employees are constantly sending signals — through surveys, conversations, emails, exit notes, or even silence. The question is: are you really hearing them?</span>
                        <span>Our <strong> Employee Insights & Sentiment Intelligence Suite </strong> is designed to help organizations deeply understand the employee experience across the full lifecycle — from onboarding to exit — and convert that understanding into actions that drive engagement, retention, and performance.</span>
                        <span>We don't just analyze feedback. We decode emotion, intent, and underlying themes — so you can move from data to decisions, from listening to impact.</span>
                    </Col>
                </Col>
            </Row>
            <Row className='big'>
                <Col className='content'>
                    <span className='title'>What We Help You Do</span>
                    <Col className='descsmall'>
                        <span>
                            <strong>Listen Smarter.</strong>
                            <br/>
                            Design targeted surveys across the employee journey — from onboarding to exit — using shorter, high-impact questions.
                        </span>
                        <span>
                            <strong>Uncover Hidden Sentiment.</strong>
                            <br/>
                            Go beyond scores with advanced text and emotion analysis to reveal what your people really feel.
                        </span>
                        <span>
                            <strong>Spot Trends Early.</strong>
                            <br/>
                            Track feedback patterns over time and across segments to flag issues before they escalate.
                        </span>
                        <span>
                            <strong>Drive Real Action.</strong>
                            <br/>
                            Turn insights into clear, targeted actions leaders can implement — not just static reports.
                        </span>
                        <span>
                            <strong>See the Bigger Picture.</strong>
                            <br/>
                            Enrich insights with external data like Glassdoor and market sentiment to stay ahead of employee expectation.
                        </span>
                    </Col>
                </Col>
                <img src={secondImage} alt='secondImage'/>
            </Row>
            <Row className='big'>
                <img src={thirdImage} alt='thirdImage'/>
                <Col className='content'>
                    <span className='title'>Our Unique Value</span>
                    <Col className='descsmall'>
                        <span>
                            <strong>Consulting-first, not tool-first</strong>
                            <br/>
                            No new platforms. We work with what you have and focus on insight, not software.
                        </span>
                        <span>
                            <strong>Human + Machine</strong>
                            <br/>
                            We blend NLP-driven analysis with real human interpretation to keep your insights grounded in reality.
                        </span>
                        <span>
                            <strong>Strategic Partnership</strong>
                            <br/>
                            We don't just provide answers; we help you ask the right questions, and support the full journey from survey design to actionable insights and recommendations
                        </span>
                        <span>
                            <strong>People & Business Aligned</strong>
                            <br/>
                            We connect feedback to business outcomes — productivity, retention, morale — so your leaders can act with purpose and clarity.
                        </span>
                    </Col>
                </Col>
            </Row>
            <Col className='small'>
                <span className='title'>Ready to Listen Better?</span>
                <Col className='content descsmall'>
                    <span>We help CHROs, People Leaders, and HRBPs cut through the noise and focus on what really matters to employees — before it affects performance, culture, or attrition.</span>
                    <span>Let's make your employee feedback strategy smarter, more strategic, and insight-driven.</span>
                    <span><strong>Explore a custom approach that fits your needs.</strong></span>
                </Col>
            </Col>
        </Col>
    )
}